/** @file Rotate-drag math: accumulates the signed world angle swept around the origin (unbounded). */
import { angle } from '@pose2d/math/angle';
import { trig } from '@pose2d/math/trig';
import type { Vec2 } from '@pose2d/math/types';

/** Rotate drag state: pivot (world), last pointer (world) and total degrees swept, CCW positive (y-up). */
export interface RotateDrag {
  origin: Vec2;
  last: Vec2;
  total: number;
}

/** World angle (degrees) of point p seen from o. */
function angleFrom(o: Vec2, p: Vec2): number {
  return angle.radToDeg(trig.atan2(p[1] - o[1], p[0] - o[0]));
}

/** Next state for the pointer at world `pointer`; a pointer on the pivot leaves the state unchanged. */
export function dragRotate(drag: RotateDrag, pointer: Vec2): RotateDrag {
  if (trig.hypot(pointer[0] - drag.origin[0], pointer[1] - drag.origin[1]) < 1e-9) return drag;
  const step = angle.shortest(angleFrom(drag.origin, drag.last), angleFrom(drag.origin, pointer));
  return { origin: drag.origin, last: [pointer[0], pointer[1]], total: drag.total + step };
}
